import React from 'react'
import { Capsule } from 'components/ui/Capsule'
import useLocaleText from 'components/useLocaleText'
import { getAiScorePresentation } from '../model/aiScore'

interface IAiScoreTagProps {
  scoreDeduction: number
  size?: 'sm' | 'md'
}

export const AiScoreTag: React.FC<IAiScoreTagProps> = ({ scoreDeduction, size = 'sm' }) => {
  const excellent = useLocaleText('excellent')
  const good = useLocaleText('good')
  const fair = useLocaleText('fair')
  const poor = useLocaleText('poor')

  const { tier } = getAiScorePresentation(100 - scoreDeduction)

  if (!tier) return null

  const labelMap: Record<string, string> = {
    excellent,
    good,
    fair,
    poor,
  }

  return (
    <Capsule
      label={<>{labelMap[tier.localeLiteral] || tier.localeLiteral}</>}
      size={size}
      bg={tier.bg}
      color={tier.text}
      borderColor={tier.border}
    />
  )
}
